import { useState, useEffect } from 'react';
import { BellIcon } from '@heroicons/react/outline';

const Alert = ({ alert, msg, show, toDo }) => {
  const [showAlert, setShowAlert] = useState(show);
  useEffect(() => {
    if(show !== showAlert) {
      setShowAlert(show)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])

  return (
    <>
      {showAlert ? (
        <div
          className={
            'text-white px-6 py-4 border-0 rounded relative mx-3 mt-2 mb-3 ' + alert.color
          }
          // " + alert.color +"
        >
          <span className='text-xl inline-block mr-5 align-middle'>
            <BellIcon className='flex-shrink-0 h-6 w-6'/>
          </span>
          <span className='inline-block align-middle mr-8'>
            <b className='capitalize'>{alert.heading}! </b> 
            {msg}
          </span>
          <button
            className='absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-4 mr-6 outline-none focus:outline-none'
            onClick={() => {
              setShowAlert(false)
              toDo(false)
            }}
          >
            <span>×</span>
          </button>
        </div>
      ) : null}
    </>
  );
};

export default function ClosingAlert({type, message, show, updateState}) {
  const alert = (alertType) => {
    switch(alertType)
    {
      case 'error':
        return {color: 'bg-danger-500',
        heading: 'Klaida'}
      case 'warning':
        return {color: 'bg-warning-500',
        heading: 'Įspėjimas'}
      default:
        return {color: 'bg-emerald-500',
        heading: 'Pavyko'}
    }
  }
  return (
      <Alert alert={alert(type)} msg={message} show={show} toDo={(value) => updateState(value)}/>
  );
}

ClosingAlert.defaultProps = {
  type: 'error',
  message: 'Įvyko klaida',
  show: true,
  updateState: () => {}
};